import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Field } from 'redux-form';
import FormTextField from '../legacyForm/FormTextField';
import { Typography, Button, Table, TableHead, TableFooter, TableBody, TableCell, TableRow } from '@material-ui/core';
import AddIcon from '@material-ui/icons/AddBox';
import RemoveIcon from '@material-ui/icons/IndeterminateCheckBox';
import _ from 'lodash';
import numberFormatter from '../../utils/numberFormatter';

const required = value => value ? undefined : 'Pole jest wymagane';

const greaterOrEquals0 = value => {
  if (value == null) return 'Pole jest wymagane';
  if (value < 0) return 'Kwota musi być większa lub równa 0';

  return undefined;
};

const BudgetCosts = ({ sum, fields, onValueChange, meta, readonly }) => (
  <div>
    <Table>
      <TableHead>
        <TableRow>
          <TableCell padding="none" style={{ minWidth: 90 }}>Nazwa</TableCell>
          <TableCell size="small" style={{ maxWidth: 90 }} >Jednostka miary<br />(np. metr, sztuka)</TableCell>
          <TableCell padding="none" style={{ maxWidth: 120 }} align="right" >Cena jednostki</TableCell>
          <TableCell size="small" align="right" style={{ maxWidth: 90 }}>Liczba jednostek<br />(np. 10 sztuk)</TableCell>
          <TableCell padding="none" style={{ maxWidth: 120 }} align="right">Łączny koszt</TableCell>
          <TableCell size="small" />
        </TableRow>
      </TableHead>
      <TableBody>
        {fields.map((costRow, index) => (
          <TableRow key={index}>
            <TableCell padding="none">
              <Field
                name={`${costRow}.name`}
                component={FormTextField}
                style={{ minWidth: 90 }}
                validate={required}
                disabled={readonly}
              />
            </TableCell>
            <TableCell size="small" >
              <Field
                style={{ maxWidth: 90 }}
                name={`${costRow}.unit`}
                component={FormTextField}
                disabled={readonly}
              />
            </TableCell>
            <TableCell padding="none" align="right" >
              <Field
                name={`${costRow}.price`}
                component={FormTextField}
                style={{ maxWidth: 120 }}
                type="number"
                parse={Number}
                onBlur={onValueChange}
                endAdornmentText="zł"
                disabled={readonly}
              />
            </TableCell>
            <TableCell size="small" align="right" >
              <Field
                name={`${costRow}.qty`}
                component={FormTextField}
                style={{ maxWidth: 90 }}
                type="number"
                parse={Number}
                onBlur={onValueChange}
                disabled={readonly}
              />
            </TableCell>
            <TableCell padding="none" align="right" style={{ alignItems: 'center' }}>
              <Field
                name={`${costRow}.value`}
                component={FormTextField}
                style={{ maxWidth: 120 }}
                type="number"
                parse={Number}
                onBlur={onValueChange}
                validate={greaterOrEquals0}
                endAdornmentText="zł"
                disabled={readonly}
              />
            </TableCell>
            <TableCell padding="none" align="right">
              <Button onClick={() => fields.remove(index)} disabled={readonly}>
                <RemoveIcon /> Usuń
              </Button>
            </TableCell>
          </TableRow>
        ))}
      </TableBody>
      <TableFooter>
        <TableRow>
          <TableCell padding="none" />
          <TableCell size="small" />
          <TableCell padding="none" align="right" />
          <TableCell size="small" align="right" />
          <TableCell padding="none" size="small" align="right">{numberFormatter.format(sum)} zł</TableCell>
          <TableCell size="small" />
        </TableRow>
      </TableFooter>
    </Table>
    <Button color="primary" onClick={() => fields.push({})} disabled={readonly}>
      <AddIcon style={{ marginRight: 8 }} /> Dodaj pozycję
    </Button>
    {meta && meta.error && meta.dirty ? <Typography variant="caption" color="error" style={{ marginTop: 10 }}>{meta.error}</Typography> : null}
  </div>
);

BudgetCosts.propTypes = {
  fields: PropTypes.object,
  meta: PropTypes.object,
  sum: PropTypes.number,
  onValueChange: PropTypes.func,
  readonly: PropTypes.bool
};

function mapStateToProps(state) {
  let sum = 0;
  if (state.form.applicationForm.values && state.form.applicationForm.values.costs) {
    state.form.applicationForm.values.costs.forEach(c => sum += (parseFloat(c.value) || 0));
  }
  return {
    sum: _.round(sum, 2),
  };
}

export default connect(mapStateToProps)(BudgetCosts);



// WEBPACK FOOTER //
// ./src/components/budget/BudgetCosts.js